import { render, staticRenderFns } from "./secManage.vue?vue&type=template&id=210a1973&scoped=true&"
import script from "./secManage.vue?vue&type=script&lang=js&"
export * from "./secManage.vue?vue&type=script&lang=js&"
import style0 from "./secManage.vue?vue&type=style&index=0&id=210a1973&scoped=true&lang=css&"
import style1 from "./secManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a1973",
  null
  
)

export default component.exports